import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { BenefitsSection } from './components/BenefitsSection';
import { AudienceSection } from './components/AudienceSection';
import { TestimonialSection } from './components/TestimonialSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full bg-[#FDFAF6] overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <MechanismSection data-id="element-3" />
      <BenefitsSection data-id="element-4" />
      <AudienceSection data-id="element-5" />
      <TestimonialSection data-id="element-6" />
      <FAQSection data-id="element-7" />
      <OfferSection data-id="element-8" />
      <Footer data-id="element-9" />
    </main>;
}